'use client';
import React, { CSSProperties, useContext } from 'react';
import classes from './style.module.scss';
// import { Typography } from '@mui/material';
import  ButtonWithIcon  from '@/components/shared/Button/button-with-icon/button-with-icon.component';
import Typography from '@/components/shared/typography/typography.component';
import { ArrowDownWhiteWithTail } from '../../../../../../public/Images';
import { CarProfileContext } from '@/contexts/carProfile.context';
import { useTranslation } from '@/hook';
import colors from '@/theme/colors.module.scss';

const CarSoldOverlay = ({
  style,
  type,
}: {
  style?: CSSProperties;
  type: 'SOLD' | 'PURCHASE_IN_PROGRESS';
}) => {
  const { scrollToPosition } = useContext(CarProfileContext);
  const { t, i18n } = useTranslation();

  const scrollOptions: ScrollToOptions = {
    left: 0,
    top: scrollToPosition - 50,
    behavior: 'smooth',
  };
  const handleScroll = () => {
    window.scrollTo(scrollOptions);
  };
  const title = type === 'SOLD' ? t('soldPage.title') : t('purchaseInProgress.title');
  const description =
    type === 'SOLD' ? t('soldPage.descriptionLong') : t('purchaseInProgress.description');

  const cta = type === 'SOLD' ? t('soldPage.CTA') : t('soldPage.CTA');
  return (
    <div className={classes.container} style={style}>
      <div className={classes.blurOverlay2} />
      <div className={classes.blurOverlay}>
        <div className={classes.contentContainer}>
          <Typography
            variant="subtitle1SemiBold"
            color={type === 'SOLD' ? colors.primary700 : colors.secondary500}
          >
            {title}
          </Typography>
          <Typography variant="body2">{description}</Typography>
          <ButtonWithIcon
            text={cta}
            img={ArrowDownWhiteWithTail}
            imgActive={ArrowDownWhiteWithTail}
            buttonClicked={handleScroll}
            active
            style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              marginTop: 'auto',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CarSoldOverlay;
